import Pagination from './Pagination';

export default class SerpPagination {
    private page: number;

    public constructor(pagination: Pagination) {
        this.page = pagination!.current;
    }

    public init = () => {
        this.initPages();
    };

    private initPages = () => {
        document.querySelectorAll('div[data-pagenumber]').forEach((element) => {
            const dataPageNumber = element.getAttribute('data-pagenumber');
            if (dataPageNumber !== null) {
                const pageNumber = Number(dataPageNumber) as number;
                if (this.page == pageNumber) {
                    element!.classList.add('pagination__page--selected');
                }
            }
        });

        const prev = document.getElementById('pagination-prev');
        if (prev && this.page === 1) {
            prev!.style.cursor = 'initial';
            prev!.firstElementChild!.classList.remove("pagination__box__arrow__enabled")
            prev!.firstElementChild!.classList.add("pagination__box__arrow__disabled");
            prev!.removeAttribute("href")
        }

        const next = document.getElementById('pagination-next');
        if (next && next!.getAttribute('data-islast') === 'true') {
            next!.style.cursor = 'initial';
            next!.firstElementChild!.classList.remove("pagination__box__arrow__enabled")
            next!.firstElementChild!.classList.add("pagination__box__arrow__disabled");
            next!.removeAttribute("href")
        }
    }
}
